import PropTypes from 'prop-types';
import React from 'react';
import { GlobalSearchResult } from './GlobalSearchResults.styles';
import ParsedLink from '../ParsedLink/ParsedLink';

const GlobalSearchResults = ({ results = [] }) => (
  <GlobalSearchResult>
    {results?.map((result) => (
      <div className="result" key={result.id}>
        <ParsedLink
          href={`/player/overview/${result.team.competition?.id}/${result.season.id}/${result.team.id}/${result.id}`}
          title={`Search Result ${result.name}`}
          key={result.id}
        >
          {`${result.name} (${result.mostCommonPosition.code}) - ${result.team.shortName}`}
        </ParsedLink>
      </div>
    ))}
  </GlobalSearchResult>
);

GlobalSearchResults.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      mostCommonPosition: PropTypes.shape({
        code: PropTypes.string.isRequired,
      }).isRequired,
      team: PropTypes.shape({
        id: PropTypes.string.isRequired,
        shortName: PropTypes.string.isRequired,
        competition: PropTypes.shape({
          id: PropTypes.string,
        }),
      }).isRequired,
      season: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    })
  ),
};

export default GlobalSearchResults;
